module.exports = __webpack_public_path__ + "static/media/report.6a3c4e15.svg";